"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, FC, ReactElement } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon, Desktop, IconProps } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
type ThemeMode = "Light" | "Dark" | "System";
interface ThemeButtonProps {
  mode: ThemeMode;
  icon: FC<IconProps>;
  isActive: boolean;
  onClick: () => void;
}
const ThemeButton: FC<ThemeButtonProps> = t0 => {
  const $ = _c(10);
  const {
    mode,
    icon: Icon,
    isActive,
    onClick
  } = t0;
  const t1 = isActive ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:bg-muted-foreground/10";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("rounded-full p-1.5 transition-colors duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `Switch to ${mode} Mode`;
  const t4 = isActive ? "fill" : "regular";
  let t5;
  if ($[2] !== Icon || $[3] !== t4) {
    t5 = <Icon className="h-4 w-4" weight={t4} />;
    $[2] = Icon;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClick || $[6] !== t2 || $[7] !== t3 || $[8] !== t5) {
    t6 = <button onClick={onClick} className={t2} aria-label={t3}>{t5}</button>;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export const ThemeToggleButton: FC = () => {
  const $ = _c(22);
  const {
    theme,
    setTheme
  } = useTheme();
  const [isMounted, setIsMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!isMounted) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="h-9 w-[110px] rounded-full bg-muted animate-pulse" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t2 = theme === "light";
  let t3;
  if ($[3] !== setTheme) {
    t3 = () => setTheme("light");
    $[3] = setTheme;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <ThemeButton mode="Light" icon={Sun} isActive={t2} onClick={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = theme === "dark";
  let t6;
  if ($[8] !== setTheme) {
    t6 = () => setTheme("dark");
    $[8] = setTheme;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <ThemeButton mode="Dark" icon={Moon} isActive={t5} onClick={t6} />;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = theme === "system";
  let t9;
  if ($[13] !== setTheme) {
    t9 = () => setTheme("system");
    $[13] = setTheme;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <ThemeButton mode="System" icon={Desktop} isActive={t8} onClick={t9} />;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t4 || $[20] !== t7) {
    t11 = <div className="flex items-center space-x-1 rounded-full bg-muted p-0.5">{t4}{t7}{t10}</div>;
    $[18] = t10;
    $[19] = t4;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};